<template>
  <div class="container">
    <div
      style="width: 980px; margin: -10px auto"
      v-for="item in imgurls"
      :key="item.id"
    >
      <el-image :src="item.url" :z-index="1"></el-image>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "RiskControl",
  components: {},
  data() {
    return {
      imgurls: [
        { id: 1001, url: require("./img/riskControl_a.jpg") },
        { id: 1002, url: require("./img/riskControl_b.jpg") },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
    
    <style scoped lang="less">
.container {
  box-sizing: border-box;
  width: 100vw;
  margin: 100px auto 30px auto;
}
</style>
    